// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"DefaultLayout_wrapperComponent__pyS+E","logo":"DefaultLayout_logo__DxMIB"};